import { Descriptions, Icon, Modal, Table } from 'antd'
import Item from 'antd/lib/list/Item'
import moment from 'moment'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { DATE_TIME_FORMAT } from '../../../../../constants/Define'
import { FilterDropdown, ListComponent, StatusComponent } from '../../../common/component/Index'
import PromotionDeactive from './UpdateStatus'
import * as Func from '../../../../../helpers/functions';
import { generateStringId } from '../../../../../utils/orders'
import { Link } from 'react-router-dom'

const ListCols = [
    'orderCode', 
    'orderId', 
    'usedTime',
];

class History extends Component {

    constructor(props) {
        super(props)
        this.state = {
            titleItemTable: Func.getTitleTable(ListCols, [], ['orderId']),
            modelItem: ListCols,
            componentTable: {
                orderCode: {
                    key: 'orderCode',
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <FilterDropdown
                            setSelectedKeys={setSelectedKeys}
                            selectedKeys={selectedKeys}
                            confirm={confirm}
                            clearFilters={clearFilters}
                            handleSearch={this.handleSearch}
                            handleReset={this.handleReset}
                        >
                        </FilterDropdown>
                    ),
                    filterIcon: filtered => (
                        <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                    ),
                    render: (text, record) => <Link to={`/orders/${record.orderId}`} className={`mr-2 colorPrimary`}>{text}</Link>
                },
                usedTime: {
                    key: 'usedTime',
                    render: (date, record) => moment(moment.utc(date).toDate()).format(DATE_TIME_FORMAT.DATE_TIME)
                },
            },
        }
    }

    render() {
        const { data, handleCancel, handleOk, t, isFetchingHistory } = this.props
        const { list, totalCount, totalPage, pageIndex, pageSize } = data
        const { titleItemTable, componentTable, modelItem } = this.state

        return (
            <Modal
                title={t('item.promotions.titleModalHistory')}
                width={1200}
                visible={!!data}
                onOk={handleOk}
                onCancel={() => handleCancel('history')}
                footer={null}
                >
                    <Descriptions bordered title={t('item.promotions.promotionInfo')} bordered column={2} size='middle' className="m-b">
                        <Item label={t('item.promotions.campaignName')} >{data.infoCode.campaignName}</Item>
                        <Item label={t('item.promotions.bundleName')}>{data.infoCode.bundleName}</Item>
                        <Item label={t('item.promotions.promotionCode')}>{data.infoCode.promotionCode}</Item>
                        <Item label={t('item.promotions.active')}>
                            <StatusComponent color={data.infoCode.isActive ? 'green' : 'red'}
                                label={data.infoCode.isActive ? t('item.promotions.active') : t('item.promotions.deactive')} />
                        </Item>
                    </Descriptions>
                    
                    <ListComponent
                        tableKey="table-history m-t"
                        bordered
                        classChildren="p-0" classParent="m-0"
                        rowKey={(record, k) => record.orderCode ? record.orderCode + generateStringId(10) : k}
                        loading={{ spinning: isFetchingHistory, size: 'large' }}
                        dataSource={Func.getDataSource(list || [], modelItem)}
                        columns={Func.columnsTable({
                            titleTable: titleItemTable,
                            component: componentTable,
                            itemName: 'promotions'
                        })}
                        onChange={this.props.onChange}
                        pagination={{ total: totalCount, totalPage: totalPage, defaultCurrent: pageIndex, defaultPageSize: pageSize }}
                        componentTableList={{}}
                        onColumnVisibleChange={this.onColumnVisibleChange}
                    />
            </Modal>
        )
    }

    onColumnVisibleChange = (column, isVisibled) => {
        const { componentTable } = this.state;
        componentTable[column.dataIndex].visible = isVisibled;
        this.setState({ componentTable })
    }
}


export default withTranslation()(History)